export default {
  setSuperUserFaqs(state, payload) {
    state.superUserFaqs = payload;
  },
  setSuperUserFaqTypes(state, payload) {
    return (state.superUserFaqTypes = payload);
  },
};
